import React, { useState, useEffect } from 'react';

import './styles.css';

import trainingsServices from '../../../../services/academy/trainingsServices';

import compare from '../../../../functions/compare';
import { days } from '../../../../functions/formatDay';

import PopupNewTraining from './PopupNewTraining';
import ClassTrainingsCardItem from './ClassTrainingsCardItem';
import { FaFutbol } from 'react-icons/fa';
import ActivityIndicator from '../../../../components/ActivityIndicator';

export default function ClassTrainingsCard(props) {
    const [popupNewTrainingVisible, setPopupNewTrainingVisible] = useState(false);
    const [trainings, setTrainings] = useState([]);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        if (props.classId)
            readTrainings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.classId]);

    async function readTrainings() {
        const response = await trainingsServices.getTrainings(props.classId);
        setFetching(false);
        if (response.status === 200) {
            setTrainings(response.data.sort((a, b) =>
                compare(
                    `${days.findIndex((item) => item === a.dia_semana.toLowerCase())}${a.hora_inicio}${a.hora_fim}`,
                    `${days.findIndex((item) => item === b.dia_semana.toLowerCase())}${b.hora_inicio}${b.hora_fim}`
                )
            ));
        } else
            alert("Erro ao ler treinos, tente novamente!");
    };

    function onDelete(index, array = trainings, setArray = setTrainings) {
        setArray([...array.slice(0, index), ...array.slice(index + 1, array.length)]);
    }

    return (
        <div className='class-page-card' id='card-trainings'>
            <div className='class-card-trainings-header'>
                <h4><b><FaFutbol />Treinos</b></h4>
                <span>{trainings.length} treinos</span>
            </div>
            {
                props.studentProfileMode ?
                    [] :
                    <>

                        <button onClick={() => setPopupNewTrainingVisible(true)}>Agendar treino</button>
                        <PopupNewTraining
                            visibility={popupNewTrainingVisible}
                            setVisibility={setPopupNewTrainingVisible}
                            classId={props.classId}
                            onCreate={readTrainings}
                        />
                    </>
            }
            {
                !fetching ?
                    trainings && trainings.length ?
                        <ul className='class-card-trainings-list'>
                            {
                                trainings.map((item, index) =>
                                    <ClassTrainingsCardItem
                                        key={item.id}
                                        index={index}
                                        id={item.id}
                                        classId={props.classId}
                                        day={item.dia_semana}
                                        start={item.hora_inicio.slice(0, 5)}
                                        end={item.hora_fim.slice(0, 5)}
                                        game={item.practiceGame}
                                        frequency={item.frequencia}
                                        canDelete={props.studentProfileMode ? false : true}
                                        onDelete={onDelete}
                                    />
                                )
                            }
                        </ul>
                        : []
                    : <ActivityIndicator />
            }
        </div>
    )
}